import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from "react-redux"
import useNavigate from '../../../../hooks/useNavigate'
import { UPDATE_HR_PACKAGE, UPDATE_HR_PACKAGE_TIME, UPDATE_TRIP_TYPE } from '../../../SearchPage/redux/action-types'
import { Hr, LOCAL_RENTAL, seoCityCarTypeName, seoCityPageName } from '../../../../../shared/utils/util-constants'
import { sourceSelector, destinationSelector, hrDefaultPackageTimeSelector, hrDefaultPackageSelector, isUnificationFlowSelector } from "../../../../common/redux/selector"
import * as S from './SeoRentalStaticTable.styles';
import { STATIC_RENTAL_TABLE_TITLE, VEHICLE_TYPE, MODEL, PER_KM_RATE, FARE, INCLUDED, VIEW_DETAILS } from '../../../../../shared/config/constants'
import { aggregateRatingSelector, minFareSchemaSelector, SeoMetaSelector, seoPageNameSelector } from '../../redux/selector';

export default function({staticTableDetails = []}) {
  const [navigateTo]          = useNavigate()
  const source                = useSelector(sourceSelector)
  const destination           = useSelector(destinationSelector)
  const hrDefaultPackage      = useSelector(hrDefaultPackageSelector)
  const hrDefaultPackageTime  = useSelector(hrDefaultPackageTimeSelector)
  const seoPageName           = useSelector(seoPageNameSelector)
  const aggregateRating       = useSelector(aggregateRatingSelector)
  const minFareSchema         = useSelector(minFareSchemaSelector)
  const seoMeta               = useSelector(SeoMetaSelector);
  const isUnificationFlow     = useSelector(isUnificationFlowSelector)
  const dispatch              = useDispatch()

  const getTitleForStaticTable = useCallback(
    () => {
      let title = ''
      if (source?.name) {
        title = `${source?.name} ${STATIC_RENTAL_TABLE_TITLE}`
      } else if (destination?.name) {
        title = `${destination?.name} ${STATIC_RENTAL_TABLE_TITLE}`
      } else {
        title = ''
      }

      return title
    },[]
  )

  const reviewAction = () => {
    batch(() => {
      dispatch({
        type: UPDATE_TRIP_TYPE,
        tripType: {
          name: LOCAL_RENTAL,
          rf: Hr
        }
      })
      dispatch({
        type: UPDATE_HR_PACKAGE,
        package_id: hrDefaultPackage
      });
      dispatch({
        type: UPDATE_HR_PACKAGE_TIME,
        packageTime: hrDefaultPackageTime
      })
    })

    navigateTo('home')
  }

  const showAggregateRating = useCallback(
    () => {
      let shouldShowAggregateRating = false
      if (aggregateRating && Object.keys(aggregateRating)?.length > 0 && (seoPageName === seoCityCarTypeName || seoPageName === seoCityPageName)) shouldShowAggregateRating = true
      return shouldShowAggregateRating
    },[]
  );

  const addProductSchema = useCallback(
    () => {
      let shouldAddProductSchema = false
      if (((aggregateRating && Object.keys(aggregateRating)?.length > 0) || minFareSchema > 0) && (seoPageName === seoCityCarTypeName || seoPageName === seoCityPageName)) shouldAddProductSchema = true
      return shouldAddProductSchema
    },[]
  );

  const addAggregateOfferSchema = useCallback(
    () => {
      let shouldAddAggregateOfferSchema = false
      if (minFareSchema > 0 && (seoPageName === seoCityCarTypeName || seoPageName === seoCityPageName)) shouldAddAggregateOfferSchema = true
      return shouldAddAggregateOfferSchema
    },[]
  );

  return (
    <>
      {getTitleForStaticTable() && <S.Title>{getTitleForStaticTable()}</S.Title>}
        <S.Table {...(addProductSchema() ? {itemType:"https://schema.org/Product", itemScope: true} : {})}>
        {seoMeta && seoMeta?.h1_title?.length > 0 ? (
          <meta itemProp="name" content={seoMeta?.h1_title} />
        ) : null }
          <S.Header itemProp="name">
            <S.TableRow>
              <S.RouteColumn {...(showAggregateRating() ? {itemType:"https://schema.org/AggregateRating", itemScope: true, itemProp:"aggregateRating"} : {})}>
                {showAggregateRating() ? (
                  <>
                    <meta itemProp="reviewCount" content={`${aggregateRating?.ratings}`} />
                    <meta itemProp="ratingValue" content={`${aggregateRating?.review}`} />
                    <span itemProp="itemReviewed" itemScope itemType="https://schema.org/Car">
                      <meta itemProp="name" content={seoMeta?.h1_title} />
                    </span>
                  </>
                ) : null}
                {VEHICLE_TYPE}
              </S.RouteColumn>
              <S.ModelColumn {...(addAggregateOfferSchema() ? {itemType:"https://schema.org/AggregateOffer", itemScope: true, itemProp:"offers"} : {})}>
                {
                  addAggregateOfferSchema() ? (
                    <>
                      <meta itemProp="lowPrice" content={`${minFareSchema}`} />
                      <meta itemProp="priceCurrency" content="INR" />
                    </>
                  ) : null
                }
                {MODEL}
              </S.ModelColumn>
              <S.perKmChargeColumn>{PER_KM_RATE}</S.perKmChargeColumn>
              <S.commonColumn>{FARE}</S.commonColumn>
              <S.commonColumn>{INCLUDED}</S.commonColumn>
            </S.TableRow>
          </S.Header>
          <S.BodyWrapper>
            {staticTableDetails?.map((route, index) => {
              return (
                <S.Body key={`${route?.type}_${index}`}>
                  <S.RouteColumn>
                    <S.RouteColumnWrapper>
                      {(route?.type || "").replace('_', ' ')}
                    </S.RouteColumnWrapper>
                  </S.RouteColumn>
                  <S.ModelColumn>
                    {(route?.vehicleModel ? `${route?.vehicleModel} ${route?.similarMessage ? route?.similarMessage : ''}` : '')}
                  </S.ModelColumn>
                  <S.perKmChargeColumn>
                    {(route?.perKmCharge ? `₹${route?.perKmCharge}` : '')}
                  </S.perKmChargeColumn>
                  <S.commonColumn>
                    {(route?.totalAmount ? `₹${route?.totalAmount}` : '')}
                  </S.commonColumn>
                  <S.commonColumn>
                    {(route?.includedKms ? `${route?.includedKms}kms` : '')}
                  </S.commonColumn>
                  <S.CTAColumn onClick={() => reviewAction()}>
                    {VIEW_DETAILS}
                  </S.CTAColumn>
                </S.Body>
              )
            })}
          </S.BodyWrapper>
        </S.Table>
    </>
  )
}